import mergeStyles from '@/lib/styling/mergeStyles';

export default function Box({style, direction='column', ...restProps}) {
    return (
        <div style={mergeStyles({display: 'flex', flexDirection: direction}, style)} {...restProps} />
    );
}
